import {useCallback, useEffect, useState} from "react";
import BuyVolumeItem from "./BuyVolumeItem";
import {ReactComponent as FeedCoin} from "../../../../../asset/icons/three-coin-icon.svg";
import DBButton from "../../../../../component/global/DBButton";
import DBCheckbox from "../../../../../component/global/DBCheckbox";
import {useTranslation} from "react-i18next";

const buyVolume = [
  {
    id: 1,
    title: '100 MB',
    price: 20000,
    unit: 'تومان',
  },
  {
    id: 2,
    title: '250 MB',
    price: 500000,
    unit: 'تومان',
  },
  {
    id: 3,
    title: '500 MB',
    price: 100000,
    unit: 'تومان',
  },
  {
    id: 4,
    title: '10000 MB',
    price: 200000,
    unit: 'تومان',
  }
]

const buyFeedCoin = [
  {
    id: 1,
    title: <>20<FeedCoin/></>,
    price: 40000,
    unit: 'تومان',
  },
  {
    id: 2,
    title: <>40<FeedCoin/></>,
    price: 80000,
    unit: 'تومان',
  },
  {
    id: 3,
    title: <>60<FeedCoin/></>,
    price: 120000,
    unit: 'تومان',
  },
  {
    id: 4,
    title: <>80<FeedCoin/></>,
    price: 160000,
    unit: 'تومان',
  }
]

function BuyVolume() {
  const [isTerms, setIsTerms] = useState(false)
  const [volume, setVolume] = useState([])
  const [feedCoin, setFeedCoin] = useState([])
  const [isError, setIsError] = useState(false)
  const {t} = useTranslation()

  const checked = useCallback((array, item) => array.some(element => element.id === item.id), [])
  const onClick = useCallback((array, item, setFunction) => {
    if (array.some(element => element.id === item.id)) {
      const tmp = array.filter(element => element.id !== item.id)
      setFunction(tmp)
    } else {
      setFunction(prevState => ([
        ...prevState,
        item
      ]))
    }
  }, [])

  useEffect(() => {
    if (isTerms) setIsError(false)
  }, [isTerms])

  return (
    <>
      <div className='buy-volume-container'>
        <div className='buy-volume-label'>
          {t('Organizational.Profile.Packages.Buy.Volume.Packages.Volume.Title')}
        </div>
        {buyVolume.map(item => {
          return (
            <BuyVolumeItem
              key={item.id}
              title={item.title}
              price={item.price}
              unit={item.unit}
              classNameContainer='buy-volume-item-container'
              classNameTitle='buy-volume-item-title'
              classNamePrice='buy-volume-item-price'
              classNameUnit='buy-volume-item-unit'
              onClick={() => onClick(volume, item, setVolume)}
              checked={checked(volume, item)}
            />
          )
        })}
      </div>
      <div className='buy-volume-container'>
        <div className='buy-volume-label'>
          {t('Organizational.Profile.Packages.Buy.Volume.Packages.FeedCoin.Title')}
        </div>
        {buyFeedCoin.map(item => {
          return (
            <BuyVolumeItem
              key={item.id}
              title={item.title}
              price={item.price}
              unit={item.unit}
              classNameContainer='buy-volume-item-container'
              classNameTitle='buy-volume-item-title'
              classNamePrice='buy-volume-item-price'
              classNameUnit='buy-volume-item-unit'
              onClick={() => onClick(feedCoin, item, setFeedCoin)}
              checked={checked(feedCoin, item)}
            />
          )
        })}
      </div>
      <div className='buy-volume-bottom-container'>
        <div className='buy-volume-bottom-terms'>
          <div className='buy-volume-bottom-terms-title'>
            {t('Organizational.Profile.Packages.Buy.Volume.Packages.Terms.Condition.Part.One')}<span> {t('Organizational.Profile.Packages.Buy.Volume.Packages.Terms.Condition.Part.Two')} </span>{t('Organizational.Profile.Packages.Buy.Volume.Packages.Terms.Condition.Part.Three')}
          </div>
          <DBCheckbox
            onClick={() => setIsTerms(prevState => !prevState)}
            checked={isTerms}
          />
        </div>
        <DBButton
          caption={t('Organizational.Profile.Packages.Buy.Volume.Packages.Submit.Title')}
          className=''
          onClick={() => {
            if (!isTerms) {
              setIsError(true)
            } else {
              console.log('isTerm', isTerms)
              console.log('volume', volume)
              console.log('feedCoin', feedCoin)
            }
          }}
        />
      </div>
      {isError ?
        <div className='buy-volume-bottom-terms-error'>
          {t('Organizational.Profile.Packages.Buy.Volume.Packages.Terms.Error')}
        </div>
        : null}
    </>

  );
}

export default BuyVolume;
